import Swiper from 'swiper/js/swiper.min';

const quizSliderElements = [...document.querySelectorAll('.j-quiz-slider')];
const optionsQuizSlider = {
    wrapperClass : 'j-quiz-slider-container',
    slideClass   : 'j-quiz-slider-slide',
    slidesPerView: 'auto'
};

quizSliderElements.forEach(() => {
    return new Swiper('.j-quiz-slider', optionsQuizSlider);
});

const quizLabels = [...document.querySelectorAll('.j-quiz-label')];
const quizInputs = [...document.querySelectorAll('.j-quiz-radio')];

const changeChecked = (label, labels, inputs) => {
    const currentId = [...label.attributes].find((attr) => {
        return attr.name === 'for';
    }).value;

    label.classList.toggle('is-active');

    inputs.forEach((input) => {
        input.checked = input.id === currentId ? !input.checked : false;
    });

    labels.forEach((labelNode) => {
        if (labelNode !== label) {
            labelNode.classList.remove('is-active');
        }
    });
};

quizLabels.forEach((label) => {
    label.addEventListener('click', () => {
        changeChecked(label, quizLabels, quizInputs);
    });
});
